export default {
  data() {
    return {
      genders: [
        {
          value: 'Masculino',
          label: 'Masculino',
        },
        {
          value: 'Femenino',
          label: 'Femenino',
        },
      ],
      ocupations: [
        {
          value: 'Actualmente sin ocupación',
          label: 'Actualmente sin ocupación',
        },
        {
          value: 'Estudiante',
          label: 'Estudiante',
        },
        {
          value: 'Ama de Casa',
          label: 'Ama de Casa',
        },
        {
          value: 'Jubilado/a',
          label: 'Jubilado/a',
        },
        {
          value: 'Profesionistas',
          label: 'Profesionistas',
        },
        {
          value: 'Técnicos/as',
          label: 'Técnicos/as',
        },
        {
          value: 'Trabajadores/as de la educación',
          label: 'Trabajadores/as de la educación',
        },
        {
          value: 'Trabajadores/as del arte, espectáculos y deportes',
          label: 'Trabajadores/as del arte, espectáculos y deportes',
        },
        {
          value:
            'Trabajadores/as en actividades agrícolas, ganaderas, silvícolas y de caza y pesca',
          label:
            'Trabajadores/as en actividades agrícolas, ganaderas, silvícolas y de caza y pesca',
        },
        {
          value:
            'Trabajadores/as de control en la fabricación artesanal e Industrial y en actividades de reparación y mantenimiento',
          label:
            'Trabajadores/as de control en la fabricación artesanal e Industrial y en actividades de reparación y mantenimiento',
        },
        {
          value:
            'Conductores/as y ayudantes de conductores de maquinaria móvil y medios de transporte',
          label:
            'Conductores/as y ayudantes de conductores de maquinaria móvil y medios de transporte',
        },
        {
          value: 'Comerciantes, empleados/as de comercio y agentes de ventas',
          label: 'Comerciantes, empleados/as de comercio y agentes de ventas',
        },
        {
          value:
            'Vendedores/as ambulantes y trabajadores/as ambulantes en servicios',
          label:
            'Vendedores/as ambulantes y trabajadores/as ambulantes en servicios',
        },
        {
          value: 'Trabajadores/as en servicios doméstico',
          label: 'Trabajadores/as en servicios domésticos',
        },
        {
          value:
            'Trabajadores/as en servicios de protección y vigilancia y fuerzas armadas',
          label:
            'Trabajadores/as en servicios de protección y vigilancia y fuerzas armadas',
        },
        {
          value: 'Otros',
          label: 'Otros',
        },
      ],
      affiliation: [
        {
          value: 'Seguro Popular',
          label: 'Seguro Popular',
        },
        {
          value: 'IMSS',
          label: 'IMSS',
        },
        {
          value: 'ISSSTE',
          label: 'ISSSTE',
        },
        {
          value: 'ISSSTECALI',
          label: 'ISSSTECALI',
        },
        {
          value: 'PEMEX',
          label: 'PEMEX',
        },
        {
          value: 'SEDENA',
          label: 'SEDENA',
        },
        {
          value: 'OTRO',
          label: 'OTRO',
        },
      ],
      maritalStatusOpt: [
        {
          value: 'Soltero/a',
          label: 'Soltero/a',
        },
        {
          value: 'Casado/',
          label: 'Casado/a',
        },
        {
          value: 'Unión Libre',
          label: 'Unión Libre',
        },
        {
          value: 'Viudo/a',
          label: 'Viudo/a',
        },
        {
          value: 'Otro',
          label: 'Otro',
        },
      ],
      tfOps: [
        {
          value: 'Si',
          label: 'Si',
        },
        {
          value: 'No',
          label: 'No',
        },
      ],
      references: [
        {
          value: 'Promotoras de Salud Visual',
          label: 'Promotoras de Salud Visual',
        },
        {
          value: 'Alianzas estatales (H. Ayuntamiento, DIF, Delegaciones)',
          label: 'Alianzas estatales (H. Ayuntamiento, DIF, Delegaciones)',
        },
        {
          value: 'Publicidad',
          label: 'Publicidad',
        },
        {
          value:
            'Hospitales o médicos (Seguro Popular, iSESALUD, otros sistemas u hospitales.)',
          label:
            'Hospitales o médicos (Seguro Popular, iSESALUD, otros sistemas u hospitales.)',
        },
        {
          value:
            'Alianzas empresariales (maquiladoras, empresarios, fábricas etc.)',
          label:
            'Alianzas empresariales (maquiladoras, empresarios, fábricas etc.)',
        },
        {
          value: 'Familiares y amigos',
          label: 'Familiares y amigos',
        },
        {
          value: 'Codet Vision Institute',
          label: 'Codet Vision Institute',
        },
        {
          value: 'Salud Digna',
          label: 'Salud Digna',
        },
        {
          value: 'Ópticas',
          label: 'Ópticas',
        },
        {
          value: 'Médicos particulares',
          label: 'Médicos particulares',
        },
        {
          value: 'Otros',
          label: 'Otros',
        },
      ],
      participateAs: [
        {
          value: 'Paciente',
          label: 'Paciente',
        },
        {
          value: 'Beneficiario',
          label: 'Beneficiario',
        },
      ],
      times: [
        {
          value: '0 - 5 Años',
          label: '0 - 5 Años',
        },
        {
          value: '6 - 10 Años',
          label: '6 - 10 Años',
        },
        {
          value: '11 -15 Años',
          label: '11 -15 Años',
        },
        {
          value: 'Más de 15 Años',
          label: 'Más de 15 Años',
        },
      ],
    };
  },
};
